/**
 * @file: form 表单验证
 * @author: wence
 */

export const validateRequire = name => {
    return {
        validate: value => {
            const val = (value || '').trim();
            return val.length === 0;
        },
        message: `${name}不能为空!`
    };
};

export const validateMax = (name, max, message) => {
    return {
        validate: value => {
            const val = (value || '').trim();
            return val.length > max;
        },
        message: message || `${name}不能超过${max}字!`
    };
};

export const validateMin = (name, min, message) => {
    return {
        validate: value => {
            const val = (value || '').trim();
            return val.length < min;
        },
        message: message || `${name}长度不能小于${min}`
    };
};

export const validateEmail = () => {
    return [{
        validate(value) {
            let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
            return value.length !== 0 && !reg.test(value);
        },
        message: '邮箱格式不正确！'
    },
    {
        validate(value) {
            return value.length > 320;
        },
        message: '邮箱长度不能超过320位！'
    }];
};

export const validatePhone = (name, isTel, phoneList) => {
    const rule = [
        {
            validate(value) {
                const val = (value || '').trim();
                return val.length === 0;
            },
            message: `${name}不能为空!`
        },
        {
            validate(value) {
                let re = /^\d{5,10}$/;
                let re9 = /^9\d{3,11}$/;
                let rePhone = /^1[3456789]\d{9}$/;
                let reTel = /^0\d{2,3}-\d{7,8}$/;

                if (!isTel) {
                    return !rePhone.test(value);
                }

                return !re.test(value)
                    && !re9.test(value)
                    && !reTel.test(value)
                    && !rePhone.test(value);
            },
            message: '号码格式不正确！'
        }
    ];

    if (isTel) {
        rule.push({
            validate(value) {
                return phoneList && phoneList.some(item => {
                    return item === value;
                });
            },
            message: '号码已在审核中！'
        });
    }
    return rule;
};

export const getValidate = (rules, value) => {
    let validate = false;
    let message = '';
    if (rules && rules.length > 0) {
        rules.forEach(rule => {
            if (validate) {
                return;
            }

            if (rule && rule.validate && rule.validate(value)) {
                validate = true;
                message = rule.message;
            }
        });
    }

    return {validate, message};
};



// WEBPACK FOOTER //
// ./src/containers/numberOptions/utils.js